const HEALTH_CHECK_PMS_PATH = '/healthCheck/pms'

/**
 * Builds a dashboard URL that opens PMS Health Check for one hotel.
 * When openTelemetry is true, the telemetry modal opens after the list loads.
 *
 * @param {object} options
 * @param {string} [options.baseUrl] - e.g. https://dashboard.directful.com (no trailing slash)
 * @param {number|string} [options.displayId]
 * @param {string} [options.subsidiaryId]
 * @param {boolean} [options.openTelemetry]
 * @param {boolean} [options.pepOnly]
 */
export function buildHealthCheckPmsDeepLink({
  baseUrl = '',
  displayId,
  subsidiaryId,
  openTelemetry = false,
  pepOnly = true
}) {
  const params = new URLSearchParams()

  if (displayId != null && String(displayId).trim() !== '') {
    params.set('q', String(displayId).trim())
  }

  if (subsidiaryId != null && String(subsidiaryId).trim() !== '') {
    params.set('subsidiaryId', String(subsidiaryId).trim())
  }

  if (openTelemetry) {
    params.set('telemetry', '1')
  }

  if (pepOnly) {
    params.set('pms', 'pep')
  }

  const origin = String(baseUrl || '').replace(/\/$/, '')
  const query = params.toString()

  return `${origin}${HEALTH_CHECK_PMS_PATH}${query ? `?${query}` : ''}`
}

export function buildHealthCheckPmsTelemetryLink(options) {
  return buildHealthCheckPmsDeepLink({ ...options, openTelemetry: true })
}

export function buildHealthCheckPmsListLink(options) {
  return buildHealthCheckPmsDeepLink({ ...options, openTelemetry: false })
}

/**
 * @param {string} search - location.search, with or without leading ?
 */
export function parseHealthCheckPmsDeepLinkQuery(search) {
  const raw = String(search || '').replace(/^\?/, '')
  const params = new URLSearchParams(raw)

  const q = params.get('q')
  const subsidiaryId = params.get('subsidiaryId')
  const telemetry = params.get('telemetry')
  const pms = params.get('pms')

  const searchQuery = q != null && q.trim() !== '' ? q.trim() : null
  const openTelemetry = telemetry === '1' || telemetry === 'true'
  const pepOnly = pms === 'pep'

  const hasDeepLink =
    searchQuery != null ||
    (subsidiaryId != null && subsidiaryId.trim() !== '') ||
    openTelemetry ||
    pepOnly

  return {
    hasDeepLink,
    searchQuery,
    subsidiaryId: subsidiaryId != null && subsidiaryId.trim() !== '' ? subsidiaryId.trim() : null,
    openTelemetry,
    pepOnly
  }
}
